import { Injectable } from '@angular/core';
import { GenericApiService } from './generic-api.service';
import { HttpClient } from '@angular/common/http';
import { CodeModel } from 'shared/definition';
/** 获取字典表数据 */
@Injectable({
    providedIn: 'root',
})
export class CodeListApiService {

    constructor(private httpClient: HttpClient) {

    }

    getCodeList(typeName: string) {
        const apiUrl = `api/${typeName}`
        return this.httpClient.get<CodeModel[]>(apiUrl);
    }
    
  /*根据类型获取字典列表*/
  getCodeListByType(typeName: string): any {
    return this.httpClient.get(`api/CodeManagement/GetCodeList/${typeName}`);
  }
}
